import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import './AnnouncementsWidgetSkeleton.scss';

export const AnnouncementsWidgetSkeleton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Skeleton
      className={'announcementTileSkeleton'}
      aria-label={t('dashboard:announcements:loading_content', { defaultValue: 'Loading Content' })}
    >
      <SkeletonItem shape="rectangle" />
    </Skeleton>
  );
};
